import React from "react";
import { Camera } from "lucide-react";
import ResponsiveImage from "./ResponsiveImage";
import { images } from "../data/images";

// Voeg hier nieuwe projectfoto's toe (WebP-varianten in /public + entry in data/images.js).
const items = [
  {
    image: images.action,
    title: "Glasbewassing met osmosewater",
    place: "Den Bosch",
    alt: "Glazenwasser van Cleven Cleaning wast streeploos een grote glaspui in Den Bosch",
    big: true,
  },
  {
    image: images.hero,
    title: "Felix aan het werk",
    place: "Rosmalen",
    alt: "Felix Cleven, glazenwasser uit Rosmalen, reinigt ramen met een telescoopsteel",
  },
  {
    image: images.vans,
    title: "Ons wagenpark",
    place: "Rosmalen",
    alt: "Bedrijfsbussen van schoonmaakbedrijf Cleven Cleaning in Rosmalen",
  },
];

const Gallery = () => (
  <section id="ons-werk" className="py-24 bg-white" aria-labelledby="gallery-heading" data-testid="gallery-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-12">
        <div>
          <span className="inline-flex items-center gap-2 px-4 py-1 bg-sky-100 text-sky-700 rounded-full text-sm font-semibold mb-4">
            <Camera className="w-4 h-4" /> Ons werk in beeld
          </span>
          <h2 id="gallery-heading" className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-800">
            Echte klussen, echte resultaten
          </h2>
        </div>
        <p className="text-lg text-slate-600 max-w-xl">
          Geen stockfoto's: dit zijn onze eigen mensen en wagens aan het werk in Rosmalen, Den Bosch en omstreken.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 md:grid-rows-2 gap-4">
        {items.map((item) => (
          <figure
            key={item.title}
            className={`group relative overflow-hidden rounded-3xl shadow-lg ${item.big ? "md:col-span-2 md:row-span-2 min-h-[320px]" : "min-h-[240px]"}`}
          >
            <ResponsiveImage
              image={item.image}
              alt={item.alt}
              sizes={item.big ? "(min-width: 768px) 66vw, 100vw" : "(min-width: 768px) 33vw, 100vw"}
              className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-slate-900/75 via-slate-900/10 to-transparent" />
            <figcaption className="absolute bottom-5 left-5 right-5">
              <p className="text-white font-bold text-lg drop-shadow">{item.title}</p>
              <p className="text-white/75 text-sm">{item.place}</p>
            </figcaption>
          </figure>
        ))}
      </div>
    </div>
  </section>
);

export default Gallery;
